module.exports = __webpack_public_path__ + "static/media/000000a.7a4840c9.JPG";